import React, { useState } from "react";
import { Card, Tabs } from "antd";
import List from './list/List';
import Add from './add/Add';
const TabPane = Tabs.TabPane;


const SliderPage = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [articleTypeEditData, setArticleTypeEditData] = useState(null);
  const [articleTypeEditFlag, setArticleTypeEditFlag] = useState(false);
  const callback = (key, data = null) => {
    setActiveTab(key);
    if (data && key === "2") {
      setArticleTypeEditData({...data});
      setArticleTypeEditFlag(true);
    } else if (key === "2") {
      setArticleTypeEditFlag(false);
      setArticleTypeEditData(null);
    }
  };

  return (
    <Card className="gx-card" title="اسلایدر">
      <Tabs activeKey={activeTab} onChange={callback}>
        <TabPane tab="لیست اسلایدرها" key="1">
          <List changeTabEvent={callback} />
        </TabPane>
        <TabPane tab="افزودن / ویرایش اسلایدر" key="2">
          <Add fields={articleTypeEditData} editSection={articleTypeEditFlag} changeTabEvent={callback} />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default SliderPage;
